const {utils, STORYBLOK_TOKEN} = require('../../src/common/config.js')
const {toKebabCase} = utils

const COMPARISON_FOLDER = 'comparatif-logiciel-rgpd/'
const COMPARISON_DATABASE_SLUG = COMPARISON_FOLDER + 'database'
const COMPARISON_TEMPLATE_SLUG = COMPARISON_FOLDER + 'template'

async function fetchLinks() {
  const {links} = await fetch(
    `https://api.storyblok.com/v2/cdn/links?token=${STORYBLOK_TOKEN}&cv=${Date.now()}`
  ).then(async (r) => await r.json())

  return links
}

function deepClone(object) {
  return JSON.parse(JSON.stringify(object))
}

function sortByDate(stories) {
  return stories.sort((a, b) => {
    const dateA = a.content.date ? new Date(a.content.date) : null
    const dateB = b.content.date ? new Date(b.content.date) : null

    if (dateA && dateB) {
      return dateB - dateA
    } else if (dateA && !dateB) {
      return -1
    } else if (!dateA && dateB) {
      return 1
    } else {
      return 0
    }
  })
}

function parseContent(stories) {
  return stories.map((s) => ({...s, content: JSON.parse(s.content)}))
}

function getComparisonSlug(a, b) {
  return `${COMPARISON_FOLDER}${toKebabCase(a)}-vs-${toKebabCase(b)}`
}

function getComparisons(arr) {
  const comparisons = []

  for (let i = 0; i < arr.length - 1; i++) {
    for (let j = i + 1; j < arr.length; j++) {
      comparisons.push({
        slug: {
          main: getComparisonSlug(arr[i].name, arr[j].name),
          alternate: getComparisonSlug(arr[j].name, arr[i].name),
        },
        names: [arr[i].name, arr[j].name],
      })
    }
  }

  return comparisons
}

async function fetchComparisonDatabase() {
  const data = await fetch(
    `https://api.storyblok.com/v2/cdn/stories/${COMPARISON_DATABASE_SLUG}?token=${STORYBLOK_TOKEN}&cv=${Date.now()}`
  ).then(async (r) => await r.json())

  if (data && data.story) return data.story.content
}

function getComparisonDatabase(stories) {
  const database = stories.find(({full_slug}) => full_slug === COMPARISON_DATABASE_SLUG)
  if (database) return database.content
}

function addComparisonPages(stories) {
  const database = getComparisonDatabase(stories)
  const template = stories.find(({full_slug}) => full_slug === COMPARISON_TEMPLATE_SLUG)

  if (database) {
    if (template) {
      const comparisons = getComparisons(database.solutions)
      const base = JSON.stringify(template)

      for (const comparison of comparisons) {
        const exist = stories.some(({full_slug}) =>
          [comparison.slug.main, comparison.slug.alternate].includes(full_slug)
        )

        if (!exist) {
          const updated = JSON.parse(
            base
              .replace(/solution-a/g, comparison.names[0])
              .replace(/solution-b/g, comparison.names[1])
          )
          stories.push({...updated, full_slug: comparison.slug.main})
        }
      }
    } else {
      throw Error(`No comparison template found: looking for ${COMPARISON_TEMPLATE_SLUG}`)
    }
  }

  return stories.filter(({full_slug}) => full_slug !== COMPARISON_TEMPLATE_SLUG)
}

async function getComparisonRedirections() {
  const links = await fetchLinks()
  const database = await fetchComparisonDatabase()

  if (database && links) {
    const comparisons = getComparisons(database.solutions)
    return comparisons.map(({slug}) => {
      if (Object.keys(links).some((k) => links[k].slug === slug.alternate)) {
        return `/${slug.main} /${slug.alternate} 302`
      }

      return `/${slug.alternate} /${slug.main} 302`
    })
  }

  return []
}

module.exports = {
  COMPARISON_FOLDER,
  COMPARISON_DATABASE_SLUG,
  COMPARISON_TEMPLATE_SLUG,
  fetchLinks,
  deepClone,
  sortByDate,
  parseContent,
  getComparisonSlug,
  getComparisons,
  fetchComparisonDatabase,
  getComparisonDatabase,
  addComparisonPages,
  getComparisonRedirections,
}
